import React, { useState, useEffect } from "react";

import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "../i18n/config";
import i18next from "i18next";
import { Row, Col } from "react-bootstrap";
import dayjs from "dayjs";
import { hours } from "../data/hours";
import CustomSelect from "./CustomSelect";
import TextareaWithCounter from "./TextareaWithCounter";
import { useTranslation } from "../hooks/useTranslation";

function GiftReceiverFormComponent({ setValue, register, handleSubmit, errors, sendNow, setSendNow, watch, ...props }) {
  const [lang, setLang] = useState("");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const giftTextAreaMaxLength = t("GiftTextAreaMaxLength");
  const SetLanguage = (l) => {
    i18next.changeLanguage(l);
  };
  const [availableHours, setAvailableHours] = useState(hours)
  const [selectedDate, setSelectedDate] = useState(dayjs());

  //show only future hours if selected date is today.
  useEffect(() => {
    const today = dayjs().format('DD-MM-YYYY')
    if (today == dayjs(selectedDate).format('DD-MM-YYYY')) {
      let futureHours = [];
      hours.map(hour => {
        const time = hour.value.split(':');
        if ((dayjs().hour(time[0]).minute(time[1])).isAfter(dayjs())) {
          futureHours.push(hour);
        }
      })
      setAvailableHours(futureHours)
      setValue('gifteeTime', futureHours[0].value)
    } else {
      setValue('gifteeTime', hours[0].value)
      setAvailableHours(hours)
    }
  }, [selectedDate])

  useEffect(() => {
    setLang(new URLSearchParams(location.search).get("lang") || "eng");
  }, []);

  useEffect(() => {
    SetLanguage(lang);
  }, [lang]);


  const gifteeDateMax = dayjs().add(50, 'year');

  return (
    <>
      <form aria-labelledby="ForSomeOneElse">
        <div className="receiver-form-wrap">
          <Row className="top-inputs" role="region" aria-labelledby="SendGiftTo">
            <Col sm={12}>
              <h3 id="SendGiftTo" aria-label={t("SendGiftTo")} className="gift-to"> {t("SendGiftTo")}</h3>
            </Col>
            <Col sm={12} md={6}>
              <label htmlFor="GiftfullNameInput"> {t("GiftReceiverFullName")}</label>
              <input type="text" name="GiftfullNameInput" aria-describedby="GiftfullNameInput-error" id="GiftfullNameInput"  {...register('GiftfullNameInput', { required: t("Required"), pattern: { value: new RegExp(t("FullNameRegex")), message: t("FullNameRegexMsg") } })} />
              <span className="error" id="GiftfullNameInput-error">{errors.GiftfullNameInput?.message}</span>
            </Col>

            <Col sm={12} md={6}>
              <label htmlFor="GiftSenderfullNameInput"> {t("GiftSenderfullNameInput")}</label>
              <input type="text" name="GiftSenderfullNameInput" id="GiftSenderfullNameInput" aria-describedby={errors.GiftSenderfullNameInput?.message ? "GiftSenderfullNameInput-error" : ""}  {...register('GiftSenderfullNameInput', { required: t("Required"), pattern: { value: new RegExp(t("FullNameRegex")), message: t("FullNameRegexMsg") } })} />
              <span className="error" id="GiftSenderfullNameInput-error">{errors.GiftSenderfullNameInput?.message}</span>
            </Col>
          </Row>
          
          <Row className="top-inputs">
            <Col sm={4}>
              <h3 id="WhenToSend" aria-label={t("WhenToSend")} className="gift-to">{t("WhenToSend")}</h3>
              <fieldset className="d-flex radio-padding flex-wrap" aria-labelledby="WhenToSend">
                <div className="d-flex align-items-center">
                  <input
                    defaultChecked
                    name="when-radio"
                    type='radio'
                    id='now'
                    onClick={() => setSendNow(true)}
                  />
                  <label className="mt-0" htmlFor="now">{t('Now')}</label>
                </div>
                <div className="d-flex align-items-center">
                  <input
                    name="when-radio"
                    type='radio'
                    id='later'
                    onClick={() => setSendNow(false)}
                  />
                  <label className="nowrap mt-0" htmlFor="later">{t('Later')}</label>
                </div>
              </fieldset>
            </Col>
            {
              !sendNow &&
              <Col sm={8}>
                <Row className="align-items-start h-100">
                  <Col sm={6} className="align-content-end mt-3">
                    <label htmlFor="date">{t('Date')}</label>
                    <div className="time-input-holder">
                      <input
                        min={new Date().toISOString().split('T')[0]}
                        max={gifteeDateMax.format('YYYY-MM-DD')}
                        defaultValue={new Date(dayjs()).toISOString().split('T')[0]}
                        onInput={(e) => {
                          if (!e.target.value) return;
                          const typed = dayjs(e.target.value);
                          // Correct silently instead of erroring: browsers can occasionally jump
                          // the year segment to an absurd value (e.g. via arrow keys near the
                          // min boundary), and that's a browser quirk rather than a meaningful
                          // user typo worth surfacing as a validation message. Only the year is
                          // replaced so the month/day the user actually picked is preserved.
                          if (typed.isAfter(gifteeDateMax)) {
                            const corrected = typed.year(dayjs().year());
                            setSelectedDate(corrected);
                            setValue('gifteeDate', corrected.format('YYYY-MM-DD'));
                            return;
                          }
                          setSelectedDate(typed);
                        }}
                        type="date"
                        id="date"
                        name="gifteeDate"
                        {...register('gifteeDate', {
                          required: t("Required"),
                          validate: (value) => {
                            if (!value) return true;
                            const isPast = dayjs(value).startOf('day').isBefore(dayjs().startOf('day'));
                            return !isPast || t("GifteeDatePastMsg");
                          },
                        })}
                        aria-describedby="gifteeDate-error"
                      />
                    </div>

                    <span className="error" id="gifteeDate-error">{errors.gifteeDate?.message}</span>
                  </Col>
                  <Col sm={6} className="align-content-end mt-3">
                    <label htmlFor="time">{t('Hour')}</label>
                    <div className="time-input-holder" aria-describedby="gifteeTime-error">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" width="64px" height="64px"><path d="M 64 13.5 C 36.2 13.5 13.5 36.2 13.5 64 C 13.5 91.8 36.2 114.5 64 114.5 C 91.8 114.5 114.5 91.8 114.5 64 C 114.5 36.2 91.8 13.5 64 13.5 z M 64 19.5 C 88.5 19.5 108.5 39.5 108.5 64 C 108.5 88.5 88.5 108.5 64 108.5 C 39.5 108.5 19.5 88.5 19.5 64 C 19.5 39.5 39.5 19.5 64 19.5 z M 64 31 C 62.3 31 61 32.3 61 34 L 61 58.800781 C 59.2 59.800781 58 61.8 58 64 C 58 67.3 60.7 70 64 70 C 66.2 70 68.199219 68.8 69.199219 67 L 84 67 C 85.7 67 87 65.7 87 64 C 87 62.3 85.7 61 84 61 L 69.199219 61 C 68.699219 60.1 67.9 59.300781 67 58.800781 L 67 34 C 67 32.3 65.7 31 64 31 z" /></svg>
                      <CustomSelect
                        register={register}
                        options={availableHours}
                        setValue={setValue}
                        fieldName="gifteeTime"
                        id="time"
                        placeholder={t("Choose") + " " + t("Hour")}
                      />
                    </div>
                    <span className="error" id="gifteeTime-error">{errors.gifteeTime?.message}</span>
                  </Col>
                </Row>
              </Col>
            }
          </Row>

          <Row className="botom-inputs gift-reciever" role="region" aria-labelledby="gift-reciever">
            <Col sm={12} md={6}>
              {
                lang === 'he'
                  ? <h3 id="gift-reciever" aria-label={t('HowToSend')} className="gift-to">{t('HowToSend')}</h3>
                  : <h3 id="gift-reciever" aria-label={t('GiftReceiverEmail')} className="gift-to">{t('GiftReceiverEmail')}</h3>
              }
              <Row className="top-inputs">
                <Col sm={12} md={12}>
                  {
                    lang === 'he' &&
                    <Row>
                      <Col sm={12} md={4}> <label htmlFor="GifteePhoneInput"> {t("GiftReceiverPhone")}</label></Col>
                      <Col sm={12} md={8}>
                        <input
                          id="GifteePhoneInput"
                          name="GifteePhoneInput"
                          type="tel"
                          {...register("GifteePhoneInput", {

                            pattern: {
                              value: new RegExp(t("PhoneRegex")),
                              message: t("PhoneRegexMsg"),
                            },
                          })}
                          aria-describedby="errGiftPhoneInput"
                        />
                        <span id="errGiftPhoneInput" className="error">{errors.GifteePhoneInput?.message}</span>

                      </Col>
                    </Row>
                  }
                </Col> 
                <Col sm={12} md={12}>
                  <Row className="mail-row">
                    <Col sm={12} md={4}><label htmlFor="GiftEmailInput"> {t("Email")}</label></Col>
                    <Col sm={12} md={8}> 
                      <input id="GiftEmailInput" type="email" name="GiftEmailInput" aria-describedby="GiftEmailInput-error"  {...register('GiftEmailInput', { required: lang === 'he' ? false : t("Required"), pattern: { value: new RegExp(t("EmailRegex")), message: t("EmailRegexMsg") } })} />
                      <span id="GiftEmailInput-error" className="error">{errors.GiftEmailInput?.message}</span></Col>
                  </Row>


                </Col>
              </Row>

            </Col>
            <Col sm={12} md={6}>
              <Row>
                <Col sm={12} md={12}><label htmlFor="GiftFreeTextInput" className="greetings-label">{(t("GiftReceiverFreeText") + " " + t("GiftReceiverFreeTextRemarks"))}</label></Col>
              </Row>

              <TextareaWithCounter
                id="GiftFreeTextInput"
                {...register("GiftFreeTextInput", { maxLength: { value: giftTextAreaMaxLength, message: t("TextAreaMaxLengthMsg") } })}
                value={watch("GiftFreeTextInput", "")}
                onChange={(e) => setValue("GiftFreeTextInput", e.target.value, { shouldValidate: true })}
                maxLength={giftTextAreaMaxLength}
                clearLabel={t("Delete")}
                errorMessage={errors.GiftFreeTextInput?.message}
              />
            </Col>
          </Row>
        </div>
      </form>
    </>
  );
}

export default GiftReceiverFormComponent;
